import css1 from '../img/portImages/css1.png';
import css2 from '../img/portImages/css2.png';
import css3 from '../img/portImages/css3.png';
import css4 from '../img/portImages/css4.png';
import js1 from '../img/portImages/js1.png';
import js2 from '../img/portImages/js2.png';
import js3 from '../img/portImages/js3.png';
import js4 from '../img/portImages/js4.png';
import react1 from '../img/portImages/react1.png';
import react2 from '../img/portImages/react2.png';
import react3 from '../img/portImages/react3.png';
import react4 from '../img/portImages/react4.png';
import react5 from '../img/portImages/react5.png';
import react6 from '../img/portImages/react6.png';
import react7 from '../img/portImages/react7.png';


const portfolios = [
    {
        id: 1,
        category: 'CSS',
        image: css1,
        link1: 'https://github.com/diyorbekxasanov/resp-portfolio2',
        link2: 'https://resp-portfolio2.netlify.app/',
        title: 'Responsive Portfolio',
        text: 'Created using HTML, CSS, SASS and JavaScript.'
    },
    {
        id: 2,
        category: 'Javascript',
        image: js1,
        link1: 'https://github.com/diyorbekxasanov/game-don-don-ziki',
        link2: 'https://game-dondonziki.netlify.app/',
        title: 'Game Don-Don-Ziki',
        text: 'Created with JavaScript'
    },
    {
        id: 3,
        category: 'Javascript',
        image: js2,
        link1: 'https://github.com/diyorbekxasanov/todos-apicall',
        link2: 'https://todos-apicall.netlify.app/',
        title: 'Todos apiCall',
        text: 'Created with JavaScript'
    },
    {
        id: 4,
        category: 'Javascript',
        image: js3,
        link1: 'https://github.com/diyorbekxasanov/calculator',
        link2: 'https://calculate-with-js.netlify.app/',
        title: 'Calculator',
        text: 'Created with JavaScript'
    },
    {
        id: 5,
        category: 'Javascript',
        image: js4,
        link1: 'https://github.com/diyorbekxasanov/weatherapp-with-js',
        link2: 'https://weatherapp-with-js.netlify.app/',
        title: 'Weather app',
        text: 'Created with JavaScript'
    },
    {
        id: 6,
        category: 'React JS',
        image: react1,
        link1: 'https://github.com/diyorbekxasanov/online-store',
        link2: 'https://online-store-reactjs.netlify.app/',
        title: 'Online store',
        text: 'Created using Bootstrap, Reactjs, Redux, fakeapi, json-server '
    },
    {
        id: 7,
        category: 'CSS',
        image: css2,
        link1: 'https://github.com/diyorbekxasanov/resp-portfolio',
        link2: 'https://resp-portfolio.netlify.app/',
        title: 'Responsive Biruang',
        text: 'Created using HTML, CSS and SASS'
    },
    {
        id: 8,
        category: 'CSS',
        image: css3,
        link1: 'https://github.com/diyorbekxasanov/responsive-biruang/settings',
        link2: 'https://lucid-fermi-6cbdb7.netlify.app/',
        title: 'Responsive Art.Design',
        text: 'Created using HTML and CSS'
    },
    {
        id: 9,
        category: 'CSS',
        image: css4,
        link1: 'https://github.com/diyorbekxasanov/zira-design',
        link2: 'https://zira01.netlify.app/',
        title: 'Zira Design (no responsive)',
        text: 'Created using HTML and CSS'
    },
    {
        id: 10,
        category: 'React JS',
        image: react2,
        link1: 'https://github.com/diyorbekxasanov/stopwatch',
        link2: 'https://stopwatch-with-reactjs.netlify.app/',
        title: 'Stopwatch',
        text: 'Created using Bootstrap, Reactjs,'
    },
    {
        id: 11,
        category: 'React JS',
        image: react3,
        link1: 'https://github.com/diyorbekxasanov/telegram-clone-locstor',
        link2: 'https://telegramm-clone.netlify.app/',
        title: 'Telegram Clone',
        text: 'Created using Bootstrap, reactstrap, Reactjs, localStorage   '
    },
    {
        id: 12,
        category: 'React JS',
        image: react4,
        link1: 'https://github.com/diyorbekxasanov/apicalls',
        link2: 'https://api-call-react.netlify.app/',
        title: 'Apicall',
        text: 'Created using Bootstrap, Reactjs, functional components '
    },
    {
        id: 13,
        category: 'React JS',
        image: react5,
        link1: 'https://github.com/diyorbekxasanov/users-api',
        link2: 'https://www.google.com',
        title: 'Users',
        text: 'Created using Bootstrap, Reactjs'
    },
    {
        id: 14,
        category: 'React JS',
        image: react6,
        link1: 'https://github.com/diyorbekxasanov/organization-programm',
        link2: 'https://serene-bhaskara-d8c270.netlify.app/',
        title: 'Company or organization program',
        text: 'Created using Bootstrap, Reactjs, Redux '
    },
    {
        id: 15,
        category: 'React JS',
        image: react7,
        link1: 'https://github.com/diyorbekxasanov/organization-programm',
        link2: 'https://serene-bhaskara-d8c270.netlify.app/',
        title: 'Company or organization program',
        text: 'Created using Bootstrap, Reactjs, Redux '
    },
    
]

export default portfolios;